import { render, staticRenderFns } from "./PrecisionMarketingDataTable2.vue?vue&type=template&id=31c09654&scoped=true"
import script from "./PrecisionMarketingDataTable2.vue?vue&type=script&lang=js"
export * from "./PrecisionMarketingDataTable2.vue?vue&type=script&lang=js"
import style0 from "./PrecisionMarketingDataTable2.vue?vue&type=style&index=0&id=31c09654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c09654",
  null
  
)

export default component.exports